import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import user1 from "../../assets/images/users/user-6.jpg"

const AdminProfile = () => {
  document.title = "Profile | My Urban Farms";
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [profileData, setProfileData] = useState({
    name: "John Anderson",
    email: "john.anderson@company.com",
    phone: "+91 123456789",
    location: "Coimbatore, India",
    position: "Admin",
    joinDate: "January 2022",
    department: "Operations",
    bio: "Experienced administrator with 8+ years in system management and team coordination. Passionate about optimizing workflows and enhancing productivity.",
  });

  const [editData, setEditData] = useState({ ...profileData });
  const [activeTab, setActiveTab] = useState("overview");

  const handleInputChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    setProfileData({ ...editData });
    setIsEditModalOpen(false);
  };

  const handleCancel = () => {
    setEditData({ ...profileData });
    setIsEditModalOpen(false);
  };

  const stats = [
    { label: "Projects", value: "42", color: "primary" },
    { label: "Tasks Completed", value: "287", color: "success" },
    { label: "Active Users", value: "1.2K", color: "info" },
    { label: "Reports", value: "58", color: "warning" },
  ];

  const recentActivity = [
    { action: "Updated system settings", time: "2 hours ago" },
    { action: "Approved user registration", time: "5 hours ago" },
    { action: "Generated monthly report", time: "1 day ago" },
    { action: "Modified access permissions", time: "2 days ago" },
  ];

  return (
    <div className="container py-4">
      {/* Header Card */}
      <div className="card shadow mb-4 border-0">
        <div
          className="card-img-top"
          style={{

          }}
        ></div>

        <div className="card-body text-center position-relative">
          {/* Avatar */}
          <div
            className="rounded-circle border border-4 border-white shadow position-absolute top-0 start-50 translate-middle"
            style={{
              width: "150px",
              height: "150px",
              background:
                "linear-gradient(to right, #0d6efd, #6f42c1)",
              color: "white",
              fontSize: "40px",
              fontWeight: "bold",
              lineHeight: "120px",
            }}
          >
     
            <img src={user1} width={140} style={{borderRadius:"50%"}}></img>
          </div>

          <div className="mt-5 pt-4">
            <h3>{profileData.name}</h3>
            <p className="text-muted mb-1">{profileData.position}</p>
            {/* <p className="text-secondary">{profileData.department}</p> */}

            <button
              onClick={() => setIsEditModalOpen(true)}
              className="btn btn-primary btn-sm mt-2"
            >
              <i className="mdi mdi-pencil me-1"></i> Edit Profile
            </button>
          </div>

          {/* Contact Info */}
          <div className="row text-center mt-4">
            <div className="col-md-4 mb-2">
              <i className="mdi mdi-email-outline me-2 text-primary"></i>
              {profileData.email}
            </div>
            <div className="col-md-4 mb-2">
              <i className="mdi mdi-phone me-2 text-success"></i>
              {profileData.phone}
            </div>
            <div className="col-md-4 mb-2">
              <i className="mdi mdi-map-marker me-2 text-danger"></i>
              {profileData.location}
            </div>
          </div>
        </div>
      </div>


   



      {/* Edit Modal */}
      {isEditModalOpen && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <button
                  className="btn-close"
                  onClick={handleCancel}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  {[
                    { label: "Full Name", name: "name" },
                    { label: "Email", name: "email" },
                    { label: "Phone", name: "phone" },
                    { label: "Location", name: "location" },
                    { label: "Position", name: "position" },
                   
                  ].map((field, i) => (
                    <div className="col-md-6" key={i}>
                      <label className="form-label">{field.label}</label>
                      <input
                        type="text"
                        name={field.name}
                        value={editData[field.name]}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  ))}
        
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminProfile;
